export enum ENV_MODES {
    DEV = 'develop',
    PROD = 'production',
}
